import "./PreviousSearchTerms.scss";

const PreviousSearchTerms = ({
    handleSelection,
    previousSearchTerms
}) => {
    const handleKeyDown = (event) => {
        if (event.keyCode === 13) handleMouseDown(event);
    };

    const handleMouseDown = (event) => {
        handleSelection(event.currentTarget.id);
    };

    return (
        <>
            {previousSearchTerms && previousSearchTerms.length > 0 &&  (
                <>
                    <div className="previous-search-terms__container">
                        <div className="previous-search-terms__heading">Previous Searches</div>
                        <ul className="previous-search-terms__list">
                            {previousSearchTerms.map((previousSearchTerm) => (
                                <li
                                    className="previous-search-terms__list-option"
                                    id={previousSearchTerm}
                                    onKeyDown={handleKeyDown}
                                    onMouseDown={handleMouseDown}
                                    role="option"
                                    tabIndex="0"
                                >
                                    <span>{previousSearchTerm}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </>
            )}
        </>
    );
};

export default PreviousSearchTerms;
